import { render, staticRenderFns } from "./TrademarkOppositionResponsibleForm.vue?vue&type=template&id=18ba9bf6&"
import script from "./TrademarkOppositionResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports